import Note from "../../../domain/sb_note.class";

export default function issueNoteTemplateService(
    $sbCurrentProject,
    $sbNoteTemplatesApi
) {
    "ngInject";

    return {
        getTemplatesForCurrentProject,
        mapTemplateTypeToNoteType,
    };

    function getTemplatesForCurrentProject() {
        const projectId = $sbCurrentProject.pick("id");

        return $sbNoteTemplatesApi
            .getCollection(projectId)
            .then(({ meta = {}, note_templates: noteTemplates = [] }) => ({
                meta,
                noteTemplates: noteTemplates.map(mapTemplate),
            }));
    }

    function mapTemplate(template) {
        return {
            id: template.key,
            code: template.code,
            text: template.text,
            type: template.type,
            noteType: mapTemplateTypeToNoteType(template.type),
        };
    }

    function mapTemplateTypeToNoteType(templateType) {
        switch (templateType) {
            case "CLAIM":
                return Note.QUALITY_ISSUE;
            case "OBSTRUCTION":
                return Note.OBSTRUCTION;
            case "INFO":
                return Note.INFORMATION;
            default:
                throw new Error(
                    `Unsupported note template type "${templateType}".`
                );
        }
    }
}
